export default {
  // Promotions Admin
  "userPromotionsAdmin.add": "添加",
  "userPromotionsAdmin.details": "详情",
  "userPromotionsAdmin.edit": "编辑",
  "userPromotionsAdmin.delete": "删除",
  "userPromotionsAdmin.delete.confirm.title": "删除配置",
  "userPromotionsAdmin.delete.confirm.content": "确定要删除这个配置吗？",
  "userPromotionsAdmin.delete.confirm.okText": "确定",
  "userPromotionsAdmin.delete.confirm.cancelText": "取消",
  "userPromotionsAdmin.modal.title": "促销配置",
  "userPromotionsAdmin.thead.createdAt": "创建时间",
  "userPromotionsAdmin.thead.updatedAt": "更新时间",
  "userPromotionsAdmin.thead.action": "操作",

  // Promotion fields
  "userPromotionsAdmin.thead.id": "ID",
  "userPromotionsAdmin.thead.documentId": "文档ID",
  "userPromotionsAdmin.thead.sort": "排序",
  "userPromotionsAdmin.thead.itemName": "活动名称",
  "userPromotionsAdmin.thead.itemId": "活动ID",
  "userPromotionsAdmin.thead.content": "内容",
  "userPromotionsAdmin.thead.listToDdetailText": "详情文本",
  "userPromotionsAdmin.thead.listOpenType": "打开方式",
  "userPromotionsAdmin.thead.openPaymentBindBonusId": "绑定奖金ID",
  "userPromotionsAdmin.thead.itemSubName": "子名称",
  "userPromotionsAdmin.thead.isMessage": "是否消息",
  "userPromotionsAdmin.thead.publishedAt": "发布时间",
  "userPromotionsAdmin.thead.locale": "语言环境",
  "userPromotionsAdmin.thead.banner": "横幅",
  "userPromotionsAdmin.thead.seo": "SEO",
  "userPromotionsAdmin.thead.listTitleIcon": "标题图标",
  "userPromotionsAdmin.thead.bindSite": "绑定站点",
  "userPromotionsAdmin.thead.type": "活动类型",
  "userPromotionsAdmin.thead.displayFlag": "显示标记",
  "userPromotionsAdmin.thead.createdBy": "创建者",
  "userPromotionsAdmin.thead.updatedBy": "更新者",
  "userPromotionsAdmin.thead.localizations": "本地化",
  "userPromotionsAdmin.thead.status": "状态",

  // SEO fields
  "userPromotionsAdmin.thead.metaTitle": "Meta标题",
  "userPromotionsAdmin.thead.metaDescription": "Meta描述",
  "userPromotionsAdmin.thead.metaImage": "Meta图片",
  "userPromotionsAdmin.thead.keywords": "关键词",
  "userPromotionsAdmin.thead.metaRobots": "Meta Robots",
  "userPromotionsAdmin.thead.metaViewport": "Meta Viewport",
  "userPromotionsAdmin.thead.canonicalURL": "规范URL",
  "userPromotionsAdmin.thead.structuredData": "结构化数据"
};